import { render, staticRenderFns } from "./costPerSector.vue?vue&type=template&id=060c48d2"
import script from "./costPerSector.vue?vue&type=script&lang=js"
export * from "./costPerSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports